import { flow, get, map, flatten } from 'lodash/fp';

export const getItemIdsForEstimate = (entities, estimateId) => flow(
  get(`estimates.byId.${estimateId}.containers`),
  map(containerId => get(`containers.byId.${containerId}.items`, entities)),
  flatten,
)(entities);

export const getItemsForEstimate = (entities, estimateId) => map(
  itemId => get(`items.byId.${itemId}`, entities),
  getItemIdsForEstimate(entities, estimateId),
);
